import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import { Arrow } from '../styled-components'
import {
  contextMenuArrowAlignmentOptions,
  contextMenuSideOptions
} from '../constants'

const ContextMenuArrow = forwardRef(
  ({ side, arrowAlignment, ...props }, forwardedRef) => {
    return (
      <Arrow
        ref={forwardedRef}
        side={side}
        arrowAlignment={arrowAlignment}
        {...props}
      />
    )
  }
)

ContextMenuArrow.propTypes = {
  arrowAlignment: PropTypes.oneOf(
    Object.values(contextMenuArrowAlignmentOptions)
  ),
  side: PropTypes.oneOf(Object.values(contextMenuSideOptions))
}

ContextMenuArrow.displayName = 'ContextMenuArrow'

export default ContextMenuArrow
